var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLesson3Bee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.872 1.222C1.258 21.408 0 42.524 0 62.61c0 16.58 24.908 30.022 55.634 30.022s55.632-13.442 55.632-30.022c0-20.086-1.256-41.202-1.872-61.388C86.948.406 71.29 0 55.634 0 39.976 0 24.318.406 1.872 1.222",
    id: "a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9453839%",
    y1: "48.9984238%",
    x2: "3.64253393%",
    y2: "45.9804421%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6B680",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CDA7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.326 20.474C28.418 20.474 4.98 11.402.25.176L0 6.37c0 14.372 24.77 26.024 55.326 26.024 30.554 0 55.326-11.652 55.326-26.024L110.394 0c-4.732 11.226-28.16 20.474-55.068 20.474",
    id: "d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.4950468%",
    y1: "47.4649908%",
    x2: "6.75956783%",
    y2: "42.9038103%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7E72",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B1AC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M0 0L114.9401 0 114.9401 96.3138 0 96.3138z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M0 0L15.0161576 0 15.0161576 31.6321473 0 31.6321473z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.88.742C18.554 3.762-3.794 17.814.546 38.672c4.342 20.87 23.81 24.222 41.892 22.382 19.152-1.948 39.562-8.898 40.036-31.596C82.893 9.482 64.751 0 45.983 0a56.17 56.17 0 00-9.104.742",
    id: "k"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.4243321%",
    y1: "44.7612948%",
    x2: "52.5083571%",
    y2: "74.047574%",
    id: "l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE26E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AF38",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.88.742a55.966 55.966 0 00-8.827 2.23c-17.488 9.738-17.668 48.47 7.73 58.502a85.04 85.04 0 006.656-.42c3.926-.4 7.906-1.01 11.756-1.922-29.234-5.03-32.448-48.076-3.78-58.952A54.72 54.72 0 0045.971 0c-3.04 0-6.096.248-9.092.742M.547 38.672c2.806 13.494 11.938 19.662 22.926 21.84C8.343 52.878-.04 32.162 11.561 11.876 3.441 18.478-1.753 27.618.547 38.672",
    id: "n"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9200301%",
    y1: "88.8306465%",
    x2: "50.3085874%",
    y2: "22.8115685%",
    id: "o"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A51C05",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C34B14",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.416 1.052C-.86 3.22-.124 5.7 1.73 7.448c7.044 6.628 9.982 12.198 12.184 17.004a1.65 1.65 0 001.874.936 1.657 1.657 0 001.312-1.634c.006-8.15-2.908-18.312-9.016-22.44C6.7.38 5.388 0 4.258 0 3.066 0 2.076.42 1.416 1.052",
    id: "q"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.2080894%",
    y1: "89.1314894%",
    x2: "49.8185087%",
    y2: "22.9335171%",
    id: "r"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A51C05",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C34B14",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.22.014C1.382.284.518 2.47.866 4.762c1.316 8.694.296 14.326-.824 18.996a1.51 1.51 0 00.816 1.722 1.498 1.498 0 001.854-.428c4.566-5.818 8.176-14.714 6.124-21.1C7.938 1.158 6.07 0 4.51 0c-.098 0-.194.006-.29.014",
    id: "t"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "39.5307378%",
    y1: "75.2639251%",
    x2: "51.4790193%",
    y2: "33.2485759%",
    id: "u"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A51C05",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C34B14",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.965 5.742C-.079 11.77-.529 24.48.42 31.564 1.79 41.81 8.355 43.228 17.525 41.18c7.068-1.576 16.88-6.756 20.684-13.248 5.15-8.792-.806-19.178-8.694-23.512C24.187 1.492 19.297 0 15.103 0 10.387 0 6.551 1.886 3.965 5.742",
    id: "w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.6409672%",
    y1: "43.1058953%",
    x2: "56.4825832%",
    y2: "72.7673733%",
    id: "x"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84B34",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB2D11",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "z",
    d: "M0 0L199.553808 0 199.553808 107.324205 0 107.324205z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -207) translate(250 207) translate(82.758 105.526)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.872 1.222C1.258 21.408 0 42.524 0 62.61c0 16.58 24.908 30.022 55.634 30.022s55.632-13.442 55.632-30.022c0-20.086-1.256-41.202-1.872-61.388C86.948.406 71.29 0 55.634 0 39.976 0 24.318.406 1.872 1.222",
    fill: "url(#b)",
    mask: "url(#c)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -207) translate(250 207) translate(83.066 147.012)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.326 20.474C28.418 20.474 4.98 11.402.25.176L0 6.37c0 14.372 24.77 26.024 55.326 26.024 30.554 0 55.326-11.652 55.326-26.024L110.394 0c-4.732 11.226-28.16 20.474-55.068 20.474",
    fill: "url(#e)",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -207) translate(250 207) translate(6.803) translate(74.119 103.686)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.94 84.062c9.47-5.11 15.326-12.052 15.326-19.612 0-13.528-.556-27.318-1.108-40.984-.252-6.224-.504-12.422-.702-18.632C88.052 4.064 72.828 3.68 57.47 3.68c-15.358 0-30.582.384-51.986 1.154-.198 6.21-.45 12.408-.702 18.632C4.23 37.132 3.674 50.922 3.674 64.45c0 7.56 5.856 14.502 15.326 19.612 9.812 5.294 23.412 8.57 38.47 8.57 15.06 0 28.658-3.276 38.47-8.57m19-19.612c0 9.02-6.598 17.09-17.264 22.848-10.322 5.57-24.54 9.016-40.206 9.016-15.666 0-29.884-3.446-40.206-9.016C6.598 81.54 0 73.47 0 64.45c0-13.312.566-27.282 1.124-41.128.278-6.866.554-13.7.756-20.312l.054-1.72 1.712-.062C26.224.41 41.918 0 57.47 0s31.246.41 53.826 1.228l1.712.062.052 1.72c.202 6.612.478 13.446.756 20.312.558 13.846 1.124 27.816 1.124 41.128",
    fill: "#D16743",
    mask: "url(#h)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.478 103.999c-.802 3.384-1.3 7.92-.99 13.92.684 13.212 5.238 17.144 8.928 17.268 5.032.17 6.908-6.124 13.234-6.01 4.922.088 6.394 2.528 9.908 5.634 3.564 3.15 9.416 3.518 13.582 1.35 5.906-3.076 9.962-10.244 20.366-10.14 10.534.108 14.49 5.776 16.028 9.528 2.434 5.946 5.718 8.976 9.752 8.262 5.112-.904 6.65-4.982 7.072-9.378.642-6.67-.332-11.504 4.222-12.428 4.82-.978 5.312 6.228 10.308 6.058 6.132-.212 7.62-14.77 5.684-23.992-4.466-21.288-42.582-23.862-58.984-23.862-16.616 0-53.992 2.204-59.11 23.79",
    fill: "#EE7E72",
    transform: "translate(-250 -207) translate(250 207) translate(6.803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.04 117.86c.102-2.408 2.038-3.406 2.162-.994.206 4.01 1.734 16.302 7.27 16.488 3.888.13 6.348-6.134 13.206-6.01 8.882.158 8.944 7.55 16.48 8.298 4.784.474 7.562-1.78 11.036-4.612 4.07-3.316 8.492-6.92 16.324-6.842 20.638.21 16.506 19.394 25.452 17.812 4.094-.724 5.212-4.028 5.566-7.74.506-5.256-.828-12.732 5.684-14.052 6.368-1.29 7.852 7.784 11.564 5.77 1.062-.574 1.914-2.144 2.612-4.51 1.306-4.428 1.61-12.462.384-17.024-1.194-4.432.95-6.532 2.796-1.908 2.214 5.544 1.996 14.34.334 19.968-1.112 3.774-3.014 6.248-5.278 7.094-6.074 2.27-8.604-6.422-11.694-5.796-3.062.62-2.48 7.904-2.758 10.804-.524 5.456-2.718 9.98-8.58 11.018-12.97 2.294-7.34-17.58-26.11-17.768-6.516-.066-10.406 3.104-13.986 6.022-4.312 3.514-7.788 6.002-13.704 5.414-8.55-.848-9.54-8.164-16.18-8.282-5.432-.098-7.336 6.21-13.262 6.01-8.716-.292-9.594-12.594-9.318-19.16",
    fill: "#E45950",
    transform: "translate(-250 -207) translate(250 207) translate(6.803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.589 124.173c31.82 0 57.772-9.874 57.772-21.982 0-12.106-25.952-21.982-57.772-21.982-31.82 0-57.772 9.876-57.772 21.982 0 12.108 25.952 21.982 57.772 21.982",
    fill: "#F4A7A2",
    transform: "translate(-250 -207) translate(250 207) translate(6.803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.019 111.867a10.154 10.154 0 01-2.628-1.752c-10.158 3.868-29.842 1.736-33.838-10.628-1.614-3.188-.97-6.508.168-10.502.576-2.018 1.55-4.11 2.976-6.252 8.034-1.612 17.182-2.524 26.892-2.524 20.062 0 37.732 3.892 48.088 9.798.372 17.32-28.498 27.992-41.658 21.86",
    fill: "#EE7E72",
    transform: "translate(-250 -207) translate(250 207) translate(6.803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.558 118.342c-4.414.446-8.92 1.552-13.284 2.668-2.658.678-2.402 3.412.002 3.29 5.166-.26 9.714-1.652 14.228-2.87 2.334-.63 2.25-3.412-.946-3.088m-88.686-7.722c-3.672-2.722-4.776-7.862-3.232-12.084 1.974-5.394 8.28-10.116 17.452-13.606 10.654-4.054 25.328-6.562 41.496-6.562 16.17 0 30.844 2.508 41.498 6.562 11.19 4.258 18.112 10.348 18.112 17.26 0 7.148-6.934 12.62-13.63 14.896-3.078 1.046-3.364-1.51-1.194-2.558 4.176-2.018 11.152-7.106 11.152-12.338 0-5.226-6.012-10.126-15.732-13.824-10.256-3.902-24.468-6.316-40.206-6.316-15.736 0-29.948 2.414-40.204 6.316-7.696 2.928-13.068 6.61-14.97 10.612-1.51 3.172-.692 7.038 1.368 9.736 2.334 3.062.652 3.804-1.91 1.906",
    fill: "#E45950",
    transform: "translate(-250 -207) translate(250 207) translate(6.803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.012 114.384c1.314 1.418.574 3.608-1.346 3.982-1.848.362-9.064-1.36-10.49-4.566-.866-1.95.396-3.53 2.244-3.454 1.468.06 8.514 2.878 9.592 4.038m40.53 6.504c3.402.064 2.942 3.228-.474 3.346-12.464.43-22.666-.552-33.646-3.252-3.338-.82-2.85-5.578 1.182-4.744 10.682 2.214 22.072 4.45 32.938 4.65M83.028 168.141a18.51 18.51 0 016.072-3.782c2.158-.812 3.298 1.232 1.246 2.604-1.804 1.204-3.75 2.152-5.51 3.424-1.906 1.374-3.502-.66-1.808-2.246m-1.856-5.356c-1.582 1.698-.28 3.322 1.806 2.246 1.248-.644 2.898-1.688 3.582-2.124 2.08-1.33.952-3.298-1.246-2.604-1.752.552-3.1 1.362-4.142 2.482",
    fill: "#FFF",
    transform: "translate(-250 -207) translate(250 207) translate(6.803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.418 157.225c-.14 5.228-1.526 11.812-8.61 9.748-6.114-1.78-6.632-8.292-3.802-13.226 1.618-2.826 4.878-6.146 8.42-5.252 3.636.918 4.074 5.642 3.992 8.73M151.43 157.225c.14 5.228 1.526 11.812 8.61 9.748 6.114-1.78 6.632-8.292 3.802-13.226-1.618-2.826-4.878-6.146-8.42-5.252-3.636.918-4.074 5.642-3.992 8.73M127.67 158.495l9.574-1.99c2.002-.044 2.33 1.516 1.896 2.618-2.358 8.542-5.47 16.9-12.386 16.29-4.844-.426-3.656-7.782-1.426-14.802a3.055 3.055 0 012.342-2.116",
    fill: "#930E03",
    transform: "translate(-250 -207) translate(250 207) translate(6.803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.347 170.29c.062 1.575.538 2.955 2.098 3.02 2.85.121 4.764-2.327 6.284-5.81-3.14-.17-6.908.23-8.382 2.79",
    fill: "#E84B34",
    transform: "translate(-250 -207) translate(250 207) translate(6.803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.296 29.795c4.252-3.6 7.43-12.504 7.45-19.286.028-10.154-8.3-12.138-10.668-1.94-1.568 6.76-.43 16.852 3.218 21.226",
    fill: "#CDE3EF",
    transform: "translate(-250 -207) translate(250 207) translate(6.803)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -207) translate(250 207) translate(6.803) translate(30.559)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#i"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.66 22.258c-1.416 3.668-3.4 6.938-5.698 8.904l-.048.042a1.83 1.83 0 01-2.582-.23C2.344 28.59 1.032 24.82.418 20.76c-.644-4.24-.548-8.882.316-12.6.898-3.876 2.65-6.306 4.61-7.416C6.462.112 7.64-.112 8.79.052c1.138.162 2.216.69 3.148 1.56 1.798 1.68 3.09 4.732 3.078 8.896-.01 3.698-.894 7.966-2.356 11.75m-6.65 4.608c1.244-1.562 2.352-3.64 3.236-5.93 1.31-3.392 2.102-7.182 2.112-10.428.008-3.056-.796-5.16-1.916-6.208-.374-.35-.77-.556-1.152-.612-.372-.052-.766.028-1.152.248-1.128.638-2.19 2.268-2.832 5.044-.76 3.276-.838 7.416-.26 11.234.382 2.518 1.04 4.858 1.964 6.652",
    fill: "#C89A6C",
    mask: "url(#j)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.103 58.8l9.052-6.86 3.44 17.6-12.056-6.03a2.718 2.718 0 01-1.526-2.235 2.721 2.721 0 011.09-2.476",
    fill: "#930E03",
    transform: "translate(-250 -207) translate(250 207) translate(6.803)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -207) translate(250 207) translate(15.025 21.122)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#k"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.88.742C18.554 3.762-3.794 17.814.546 38.672c4.342 20.87 23.81 24.222 41.892 22.382 19.152-1.948 39.562-8.898 40.036-31.596C82.893 9.482 64.751 0 45.983 0a56.17 56.17 0 00-9.104.742",
    fill: "url(#l)",
    mask: "url(#m)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -207) translate(250 207) translate(15.025 21.122)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#n"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.88.742a55.966 55.966 0 00-8.827 2.23c-17.488 9.738-17.668 48.47 7.73 58.502a85.04 85.04 0 006.656-.42c3.926-.4 7.906-1.01 11.756-1.922-29.234-5.03-32.448-48.076-3.78-58.952A54.72 54.72 0 0045.971 0c-3.04 0-6.096.248-9.092.742M.547 38.672c2.806 13.494 11.938 19.662 22.926 21.84C8.343 52.878-.04 32.162 11.561 11.876 3.441 18.478-1.753 27.618.547 38.672",
    fill: "url(#o)",
    mask: "url(#p)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M87.766 36.152c4.374 26.704-19.35 36.9-41.296 39.132C26.868 77.278 6.076 72.818 2.38 50.24c-3.548-21.656 19.188-35.516 37.598-38.77 18.85-3.332 44.206 2.834 47.788 24.682M5.994 49.65C9.352 70.122 28.578 73.414 46.11 71.632c19.644-1.998 42.018-10.62 38.04-34.89-3.214-19.616-26.806-24.608-43.482-21.67C24.41 17.936 2.798 30.164 5.994 49.65",
    fill: "#E47C1E",
    transform: "translate(-250 -207) translate(250 207) translate(11.175 8.719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.301 19.803c-.986-5.492-7.088-12.7-12.94-16.108-8.76-5.102-14.638 1.134-7.01 8.288 5.056 4.742 14.346 8.8 19.95 7.82",
    fill: "#CDE3EF",
    transform: "translate(-250 -207) translate(250 207) translate(11.175 8.719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.252 10.026c2.432 3.028 4.252 6.348 4.822 9.31l.034.158c.17 1-.5 1.95-1.498 2.12-3.046.532-6.954-.216-10.772-1.712-3.982-1.56-7.948-3.968-10.736-6.582C1.204 10.6-.02 7.87 0 5.624.012 4.338.412 3.2 1.132 2.278 1.838 1.376 2.834.704 4.056.33c2.352-.722 5.632-.316 9.222 1.774 3.188 1.858 6.434 4.76 8.974 7.922m.656 8.074c-.728-1.856-1.972-3.858-3.51-5.774-2.274-2.828-5.152-5.41-7.956-7.044-2.638-1.536-4.86-1.894-6.324-1.444-.486.148-.862.388-1.102.698-.228.29-.354.67-.358 1.116-.012 1.306.866 3.048 2.942 4.994 2.444 2.292 5.982 4.428 9.572 5.834 2.366.928 4.72 1.526 6.736 1.62",
    fill: "#C89A6C",
    transform: "translate(-250 -207) translate(250 207) translate(11.175 8.719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.623 47.239c-2.61.064-5.224-2.41-5.34-5.072-.086-1.97.91-4.072 2.514-5.64 1.658-1.62 4.536-3.26 6.79-1.958.998.578 1.452 1.524 1.59 2.582.412 3.116-1.926 9.998-5.554 10.088M59.205 48.152c-1.91-1.848-.608-3.98 1.812-2.796 1.6.782 3.432 1.27 5.744.176 2.308-1.092 3.112 1.39 1.434 2.966-2.358 2.212-6.45 2.112-8.99-.346",
    fill: "#930E03",
    transform: "translate(-250 -207) translate(250 207) translate(11.175 8.719)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -207) translate(250 207) translate(54.044 11.01)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "s",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#q"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.416 1.052C-.86 3.22-.124 5.7 1.73 7.448c7.044 6.628 9.982 12.198 12.184 17.004a1.65 1.65 0 001.874.936 1.657 1.657 0 001.312-1.634c.006-8.15-2.908-18.312-9.016-22.44C6.7.38 5.388 0 4.258 0 3.066 0 2.076.42 1.416 1.052",
    fill: "url(#r)",
    mask: "url(#s)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.102 56.52c2.102.062 4.21-2.312 4.304-4.864.068-1.89-.734-3.906-2.028-5.41-1.334-1.554-3.654-3.128-5.47-1.878-.804.554-1.17 1.462-1.282 2.476-.332 2.99 1.554 9.59 4.476 9.676",
    fill: "#930E03",
    transform: "translate(-250 -207) translate(250 207)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -207) translate(250 207) translate(81.544 11.774)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "v",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#t"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.22.014C1.382.284.518 2.47.866 4.762c1.316 8.694.296 14.326-.824 18.996a1.51 1.51 0 00.816 1.722 1.498 1.498 0 001.854-.428c4.566-5.818 8.176-14.714 6.124-21.1C7.938 1.158 6.07 0 4.51 0c-.098 0-.194.006-.29.014",
    fill: "url(#u)",
    mask: "url(#v)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80.944 105.998a18.51 18.51 0 00-6.072-3.782c-2.158-.812-3.298 1.232-1.246 2.604 1.804 1.204 3.75 2.152 5.51 3.424 1.906 1.374 3.502-.66 1.808-2.246m1.856-5.356c1.582 1.7.28 3.322-1.806 2.246-1.248-.644-2.898-1.688-3.582-2.124-2.08-1.33-.952-3.298 1.246-2.604 1.752.554 3.1 1.362 4.142 2.482",
    fill: "#FFF",
    transform: "translate(-250 -207) translate(250 207) translate(99.821 64.914)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.532 11.816C-1.24 28.24 11.984 41.838 30.824 42.23c15.506.322 18.06-9.442 14.402-22.33C40.3 2.552 27.052-1.222 14.532 11.816",
    fill: "#E84B34",
    transform: "translate(-250 -207) translate(250 207) translate(99.821 64.914)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.294 22.59c2.1.128 2.48-1.724.524-2.564-1.17-.504-2.854-1.056-3.554-1.284-2.128-.69-2.85 1.238-1.096 2.378 1.398.91 2.742 1.386 4.126 1.47M23.424 32.462c2.098.126 2.48-1.724.524-2.564-1.17-.504-2.854-1.056-3.554-1.284-2.128-.69-2.85 1.238-1.096 2.378 1.398.908 2.742 1.386 4.126 1.47M34.935 30.804c2.078-.322 2.06-2.212-.032-2.618-1.248-.242-3.01-.424-3.742-.498-2.226-.222-2.526 1.816-.57 2.556 1.56.592 2.974.772 4.344.56M32 12.455c1.358 1.61.106 3.022-1.738 1.954-1.102-.638-2.55-1.66-3.15-2.084-1.826-1.298-.716-3.032 1.244-2.304 1.564.578 2.748 1.372 3.644 2.434",
    fill: "#EE7E72",
    transform: "translate(-250 -207) translate(250 207) translate(99.821 64.914)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.538 25.511C7.172 35.19 17.616 41.955 30.824 42.23c15.506.322 18.06-9.44 14.4-22.33a38.08 38.08 0 00-.786-2.456c1.798 10.562-1.828 18.058-15.446 17.776-9.71-.202-17.928-3.912-21.454-9.708",
    fill: "#E63A24",
    transform: "translate(-250 -207) translate(250 207) translate(99.821 64.914)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.009 41.136c8.124-2.872 9.098-11.084 6.216-21.236-1.41-4.968-3.506-8.822-6.068-11.488-3.69 6.242-4.08 18.36-3.164 25.214.458 3.422 1.496 5.858 3.016 7.51",
    fill: "#E63A24",
    transform: "translate(-250 -207) translate(250 207) translate(99.821 64.914)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45 11.826C4.688 11.062.986 14.702 0 19.372c5.67 4.818 13.08 1.868 13.978-5.242 3.692-3.226 5.384-8.37.932-14.13-4.578 1.188-8.104 7.19-5.46 11.826",
    fill: "#7F930F",
    transform: "translate(-250 -207) translate(250 207) translate(99.821 64.914)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.416 14.683c4.402.014 7.476-4.434 10.146-8.226-5.3-2.28-13.654-2.416-13.258 6.916-6.578 3.42-5.054 12.322 1.912 15.862 3.678-3.718 5.284-10.79 1.2-14.552",
    fill: "#ACAC00",
    transform: "translate(-250 -207) translate(250 207) translate(99.821 64.914)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -207) translate(250 207) translate(139.259 67.446)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "y",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#w"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.965 5.742C-.079 11.77-.529 24.48.42 31.564 1.79 41.81 8.355 43.228 17.525 41.18c7.068-1.576 16.88-6.756 20.684-13.248 5.15-8.792-.806-19.178-8.694-23.512C24.187 1.492 19.297 0 15.103 0 10.387 0 6.551 1.886 3.965 5.742",
    fill: "url(#x)",
    mask: "url(#y)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M166.38 35.15s4.206-2.974 7.488-1.094c3.282 1.878 3.68 8.132 3.68 8.132l-11.024-.762-.144-6.276z",
    fill: "#7F930F",
    transform: "translate(-250 -207) translate(250 207) translate(0 33.132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.045 34.198s1.944 3.778 5.924 4.684c1.042.236 2.156.432 3.232.588-2.972 1.936-4.204 5.592-3.86 11.182 5.592 1.416 10.208-1.256 11.76-5.544.684 1.266 1.652 2.53 3.012 3.416 3.874 2.522 7.658 3.358 7.658 3.358.708-12.602-3.9-14.552-10.972-13.588-3.552-6.81-8.414-10.836-16.754-4.096",
    fill: "#ACAC00",
    transform: "translate(-250 -207) translate(250 207) translate(0 33.132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.763 64.527c-1.666 1.288-3.248-.442-1.742-1.95 1.392-1.394 2.524-3.004 3.866-4.446 1.524-1.64 3.184-.318 2.142 1.5a16.824 16.824 0 01-4.266 4.896M155.277 61.96c-.574 2.028 1.148 2.798 2.386 1.062.742-1.038 1.642-2.566 2.012-3.202 1.13-1.936-.594-3.058-2.082-1.584-1.184 1.174-1.938 2.388-2.316 3.724M147.35 49.863c-.574 2.028 1.148 2.798 2.386 1.062.742-1.038 1.642-2.566 2.012-3.202 1.13-1.936-.594-3.058-2.082-1.584-1.184 1.174-1.938 2.388-2.316 3.724M146.36 62.452c-.132 2.104 1.714 2.49 2.558.53.504-1.17 1.06-2.856 1.288-3.556.694-2.132-1.228-2.862-2.37-1.106-.91 1.4-1.388 2.746-1.476 4.132",
    fill: "#EE7E72",
    transform: "translate(-250 -207) translate(250 207) translate(0 33.132)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -207) translate(250 207) translate(0 33.132)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "A",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.298 49.712a1.967 1.967 0 00-.914 1.766c.084 1.498 1.73 2.354 2.998 1.56a48.216 48.216 0 013.266-1.89c2.27-1.228.484-4.656-1.83-3.472a52.542 52.542 0 00-3.52 2.036M6.234 60.716a1.972 1.972 0 00-.058 2.25 1.959 1.959 0 003.212.08c.732-1 1.514-1.952 2.348-2.868 1.75-1.938-1.136-4.546-2.882-2.662-.922.984-1.824 2.112-2.62 3.2M.022 76.012c-.35 2.51 3.51 3.146 3.882.536.164-1.216.404-2.422.718-3.608.666-2.448-3.094-3.554-3.784-1.018a33.176 33.176 0 00-.816 4.09m1.932 16.462c1.058 2.4 4.598.812 3.602-1.546a22.293 22.293 0 01-1.144-3.414c-.644-2.536-4.394-1.56-3.806.936.342 1.368.79 2.73 1.348 4.024m11.602 12.04c2.282 1.12 4.058-2.382 1.71-3.534a21.036 21.036 0 01-3.094-1.818c-2.128-1.496-4.362 1.698-2.274 3.2a25.049 25.049 0 003.658 2.152m16.304 2.674c2.588-.226 2.256-4.096-.312-3.914a33.647 33.647 0 01-3.702.112c-2.576-.046-2.7 3.834-.112 3.926a37.88 37.88 0 004.126-.124m15.68-4.168a1.968 1.968 0 00.946-2.8 1.956 1.956 0 00-2.444-.828 68.172 68.172 0 01-3.552 1.374c-2.428.856-1.144 4.566 1.29 3.708a70.138 70.138 0 003.76-1.454m14.162-7.38c2.194-1.348.198-4.682-2.038-3.356-1.098.672-2.206 1.33-3.324 1.97-1.658.95-1.118 3.482.798 3.662.41.032.78-.046 1.14-.248 1.152-.66 2.292-1.336 3.424-2.028m13.094-8.964c.446-.33.736-.858.778-1.41.128-1.692-1.768-2.74-3.126-1.734a181.726 181.726 0 01-3.126 2.3c-.64.46-.944 1.26-.77 2.03.314 1.368 1.912 1.982 3.052 1.162a195.474 195.474 0 003.192-2.348m12.3-9.952c.626-.54.84-1.408.552-2.182a1.96 1.96 0 00-3.114-.792c-.98.85-1.968 1.69-2.96 2.524a1.961 1.961 0 00-.65 1.966 1.958 1.958 0 003.162 1.048c1.01-.846 2.012-1.702 3.01-2.564M96.27 66.468c1.878-1.836-.916-4.59-2.732-2.814-.93.906-1.866 1.806-2.808 2.7-1.894 1.806.826 4.59 2.692 2.854.956-.908 1.906-1.82 2.848-2.74m8.63-8.784c.592-.658.68-1.602.22-2.358a1.955 1.955 0 00-3.112-.292c-.876.962-.99 1.078-1.874 2.032-1.78 1.918 1.124 4.556 2.86 2.684.898-.962 1.02-1.094 1.906-2.066m24.206-25.846c1.374-1.378.15-3.694-1.758-3.326-.388.082-.71.25-.992.528-.936.926-1.87 1.856-2.794 2.794-.384.396-.574.89-.562 1.44.064 1.728 2.134 2.54 3.352 1.318.912-.924 1.83-1.842 2.754-2.754m11.426-10.542c1.344-1.156.602-3.352-1.174-3.456a1.953 1.953 0 00-1.368.468 176.042 176.042 0 00-2.988 2.602c-1.41 1.28-.392 3.6 1.504 3.422a1.963 1.963 0 001.1-.486c.966-.86 1.942-1.71 2.926-2.55m12.308-9.302a1.967 1.967 0 00.868-1.924 1.959 1.959 0 00-3.01-1.366c-1.118.728-2.22 1.476-3.308 2.248-.6.432-.904 1.14-.806 1.874a1.959 1.959 0 003.076 1.328 97.6 97.6 0 013.18-2.16m13.532-6.736c2.468-.824 1.252-4.512-1.204-3.738a45.121 45.121 0 00-3.84 1.428 1.966 1.966 0 00-.244 3.488 1.948 1.948 0 001.784.124 40.464 40.464 0 013.504-1.302m14.42-.772c2.56.55 3.356-3.252.866-3.83a29.825 29.825 0 00-4.138-.648c-1.756-.156-2.804 1.95-1.62 3.268.336.376.792.602 1.294.646a25.74 25.74 0 013.598.564m11.498 7.73c.998 1.468 3.256.98 3.56-.776a1.961 1.961 0 00-.306-1.414 21.706 21.706 0 00-2.726-3.334c-1.408-1.378-3.73-.084-3.28 1.87.09.354.262.658.522.918.832.826 1.58 1.76 2.23 2.736m3.218 13.666c-.182 1.72 1.734 2.818 3.128 1.788.436-.332.698-.8.764-1.344.102-1.512.21-2.728.12-4.264-.128-1.836-2.452-2.512-3.536-1.042-.276.386-.4.81-.376 1.284.078 1.284-.016 2.314-.1 3.578m-4.862 12.28a1.96 1.96 0 00-.282 1.926c.546 1.412 2.44 1.69 3.366.496a33.106 33.106 0 002.364-3.436 1.967 1.967 0 00-.162-2.244c-.852-1.058-2.512-.938-3.204.232a28.98 28.98 0 01-2.082 3.026m-8.454 7.11a1.968 1.968 0 00-.782 3.172c.558.588 1.348.792 2.114.522 1.322-.474 1.726-.726 2.956-1.406 2.284-1.282.318-4.68-1.902-3.434-1.036.58-1.27.746-2.386 1.146",
    fill: "#C89A6C",
    mask: "url(#A)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLesson3Bee);
export default __webpack_public_path__ + "static/media/lesson3-bee.67634a4348a353e1e4af292b77781c9e.svg";
export { ForwardRef as ReactComponent };